import { defineStore } from "pinia";
import Services from '@/services/rationCardServices'
import { mapRationCard } from '@/helpers/mapFuncs'

export const useRationCardStore = defineStore("rationCard", {

state:()=>({
    rationCard: {},
    rationCards: [],
}),
getters : {
    getRationCard() {
        return mapRationCard(this.rationCard)
    },
    getRationCards() {
        return this.rationCards.map(mapRationCard)
    }
},
actions : {
    /** Start Sets */
    setRationCard(rationCard) {
        this.rationCard = rationCard
    },
    setRationCards(rationCards) {
        this.rationCards = rationCards
    },
    /** End Sets */

    /** Start Actions */
    get(id) {
        return Services.get(id)
        .then((response)=>{
            this.setRationCard(response.data.data)
            return response
        })
    },
    getByPersonId(personId) {
        return Services.getByPersonId(personId)
        .then((response)=>{
            this.setRationCard(response.data.data)
            return response
        })
    },
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            this.setRationCards(response.data.data)
            return response
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.rationCards.push(response.data.data)
            return mapRationCard(response.data.data)
        })
    },
    edit(id, data){
        return Services.edit(id, data)
        .then((response)=>{
            this.rationCards[this.rationCards.findIndex((x)=>x.id == id)] = response.data.data
            return mapRationCard(response.data.data)
        })
    },
    delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.rationCards = this.rationCards.filter((x)=>x.id != id)
            return response
        })
    },
    /** End Actions */
}
});